/* ODC Halloween 2026 'Notturna da Paura' — behaviour of the switchable layer (snippets/odc-halloween.liquid).
   Runs only while <html> has hw-on (set server-side). Bar and collection band are server-rendered. */
(function () {
  'use strict';
  var C = window.ODC_HW || {};
  var HW = { code: C.code || '', percent: C.percent || '', end: C.end || '', endLabel: C.endLabel || '', endShort: C.endShort || '',
             link: C.link || '/collections/tutte-le-maglie' };
  var NAVY = '#0a131d', PUMP = '#ff7a1a', BATN = '#2b3b4c';
  var html = document.documentElement, path = location.pathname;
  var enc = function (s) { return 'url("data:image/svg+xml,' + encodeURIComponent(s) + '")'; };
  var uid = 0;

  if (!html.classList.contains('hw-on')) return;
  var tm = html.className.match(/hw-tpl-([\w-]+)/), tpl = tm ? tm[1] : 'other';
  var mystery = html.classList.contains('hw-sfx-mystery');

  /* ---------- svg kit ---------- */
  var BAT = 'M16 3.3c-.7 0-1.2.5-1.4 1.1C13 3.3 10.5 2.3 7.8 2.5 4.8 2.7 2.1 4.2.6 6.4c1.7-.6 3.5-.5 4.7.5 1.1-.8 2.8-.8 3.8.2 1-.7 2.6-.4 3.4.6.7 1 1.4 2.2 2.2 3.4L16 12.9l1.3-1.8c.8-1.2 1.5-2.4 2.2-3.4.8-1 2.4-1.3 3.4-.6 1-1 2.7-1 3.8-.2 1.2-1 3-1.1 4.7-.5-1.5-2.2-4.2-3.7-7.2-3.9-2.7-.2-5.2.8-6.8 1.9-.2-.6-.7-1.1-1.4-1.1zM15 3.6l.3-1.9.7 1.5zM17 3.6l-.3-1.9-.7 1.5z';
  function bat(x, y, w, rot, fill) {
    var s = w / 32;
    return '<g transform="translate(' + (x - w / 2).toFixed(1) + ' ' + (y - 7 * s).toFixed(1) + ') rotate(' + rot + ' ' + (w / 2).toFixed(1) + ' ' + (7 * s).toFixed(1) + ') scale(' + s.toFixed(3) + ')"><path d="' + BAT + '" fill="' + fill + '"/></g>';
  }
  function glyph(fill, rib, size) {
    size = size || 16;
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="' + size + '" height="' + size + '" aria-hidden="true" focusable="false">' +
      '<path d="M7.3 4.4c-.2-1.5.4-2.9 1.9-3.5l.6.9c-1 .5-1.3 1.4-1.2 2.5z" fill="' + fill + '"/>' +
      '<path d="M8 4.3C6.9 3.5 5.4 3.5 4.4 4.2 2.3 4.4 1 6.6 1 9.5s1.6 5.2 3.6 5.4c1.1.7 2.4.6 3.4.1 1 .5 2.3.6 3.4-.1 2-.2 3.6-2.5 3.6-5.4s-1.3-5.1-3.4-5.3c-1-.7-2.5-.7-3.6.1z" fill="' + fill + '"/>' +
      '<path d="M5.6 4.7c-1 2-1 7.9 0 9.9M10.4 4.7c1 2 1 7.9 0 9.9" fill="none" stroke="' + rib + '" stroke-width=".85" stroke-linecap="round"/></svg>';
  }
  function jack(lit, stem, carveFill, ring) {
    var id = 'hwj' + (++uid);
    var carve = lit ? 'url(#' + id + 'g)' : (carveFill || '#ffffff');
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" aria-hidden="true" focusable="false"><defs>' +
      '<radialGradient id="' + id + 'g" cx="50%" cy="50%" r="65%"><stop offset="0" stop-color="#ffc98a"/><stop offset=".5" stop-color="#ff9a47"/><stop offset="1" stop-color="#ff7a1a"/></radialGradient>' +
      '<clipPath id="' + id + 'c"><circle cx="32" cy="34" r="27.5"/></clipPath></defs>' +
      '<circle cx="32" cy="34" r="27.5" fill="#f2f4ef"/>' +
      '<g clip-path="url(#' + id + 'c)" fill="#0a131d"><path d="M25.5 8.5 32 4l6.5 4.5-2.5 7h-8z"/><path d="M1 25l7.5-2.5L13 29l-4.5 6.5L1 33z"/>' +
      '<path d="M63 25l-7.5-2.5L51 29l4.5 6.5L63 33z"/><path d="M3 46l6-3.5 5 4-1.5 7L5 55z"/><path d="M61 46l-6-3.5-5 4 1.5 7L59 55z"/></g>' +
      '<path d="M32 15.5v11M37.2 30.2 51 29M26.8 30.2 13 29" stroke="#0a131d" stroke-width="1.3" fill="none" stroke-linecap="round"/>' +
      '<path d="M32 26.5l5.2 3.8-2 6.2h-6.4l-2-6.2z" fill="#0a131d"/>' +
      '<g fill="' + carve + '" stroke="#0a131d" stroke-width="1.5" stroke-linejoin="round"><path d="M15.5 28.5 21 19l5.4 9.5z"/><path d="M37.6 28.5 43 19l5.5 9.5z"/>' +
      '<path d="M14.5 40.5l4 2.8 3-2.3 3.3 3.2 3.4-2.5 3.8 3.3 3.8-3.3 3.4 2.5 3.3-3.2 3 2.3 4-2.8c-1.6 8.3-8.6 13-17.5 13S16.1 48.8 14.5 40.5z"/></g>' +
      '<circle cx="32" cy="34" r="27.5" fill="none" stroke="' + (ring || '#0a131d') + '" stroke-width="2.6"/>' +
      '<path d="M31.2 6.6c-.5-2.6.9-4.6 3.9-4.9" fill="none" stroke="' + (stem || '#64de19') + '" stroke-width="2.8" stroke-linecap="round"/></svg>';
  }
  function moonDefs(id) {
    return '<radialGradient id="' + id + '" cx="40%" cy="38%" r="62%"><stop offset="0" stop-color="#ffe3bd"/><stop offset=".34" stop-color="#ffc98a"/><stop offset=".64" stop-color="#ff9a47"/><stop offset=".9" stop-color="#ff7a1a"/><stop offset="1" stop-color="#e8650f"/></radialGradient>';
  }
  function moonBats() {
    var id = 'hwm' + (++uid);
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 56" aria-hidden="true" focusable="false"><defs>' + moonDefs(id + 'g') +
      '<radialGradient id="' + id + 'l"><stop offset="0" stop-color="#ff7a1a" stop-opacity=".32"/><stop offset="1" stop-color="#ff7a1a" stop-opacity="0"/></radialGradient>' +
      '<mask id="' + id + 'm"><rect width="120" height="56" fill="#fff"/><circle cx="99" cy="19" r="15" fill="#000"/></mask></defs>' +
      '<circle cx="90" cy="25" r="26" fill="url(#' + id + 'l)"/><circle cx="90" cy="25" r="17" fill="url(#' + id + 'g)" mask="url(#' + id + 'm)"/>' +
      bat(50, 32, 22, -8, BATN) + bat(66, 16, 15, 10, BATN) + bat(84, 36, 13, -6, NAVY) + '</svg>';
  }
  /* friendly ghost, 40x48 base */
  function ghostG(x, y, w, rot) {
    var s = w / 40;
    return '<g transform="translate(' + x + ' ' + y + ') rotate(' + rot + ' ' + (w / 2).toFixed(1) + ' ' + (24 * s).toFixed(1) + ') scale(' + s.toFixed(3) + ')">' +
      '<path d="M20 2C9.5 2 4 10 4 20.5V44l5-4 5.3 5 5.7-5 5.7 5 5.3-5 5 4V20.5C36 10 30.5 2 20 2z" fill="#f2f4ef"/>' +
      '<ellipse cx="14.5" cy="19" rx="2.7" ry="3.8" fill="#0a131d"/><ellipse cx="25.5" cy="19" rx="2.7" ry="3.8" fill="#0a131d"/>' +
      '<ellipse cx="20" cy="29" rx="2.6" ry="3.2" fill="#0a131d"/></g>';
  }
  function ghost() {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 48" aria-hidden="true" focusable="false">' + ghostG(0, 0, 40, 0) + '</svg>';
  }
  function web(stroke) {
    var f = function (n) { return n.toFixed(1); }, angs = [0, 22.5, 45, 67.5, 90], d = '';
    angs.forEach(function (a) { var r = a * Math.PI / 180; d += 'M0 0L' + f(66 * Math.cos(r)) + ' ' + f(66 * Math.sin(r)); });
    [14, 26, 40, 56].forEach(function (R) {
      for (var i = 0; i < 4; i++) {
        var a1 = angs[i] * Math.PI / 180, a2 = angs[i + 1] * Math.PI / 180, am = (a1 + a2) / 2;
        d += 'M' + f(R * Math.cos(a1)) + ' ' + f(R * Math.sin(a1)) + 'Q' + f(R * .8 * Math.cos(am)) + ' ' + f(R * .8 * Math.sin(am)) + ' ' + f(R * Math.cos(a2)) + ' ' + f(R * Math.sin(a2));
      }
    });
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" aria-hidden="true" focusable="false"><path d="' + d + '" fill="none" stroke="' + stroke + '" stroke-width="1" vector-effect="non-scaling-stroke"/></svg>';
  }
  function batsSvg(w, h, list) {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + w + ' ' + h + '" aria-hidden="true" focusable="false">' +
      list.map(function (b) { return bat(b[0], b[1], b[2], b[3], b[4]); }).join('') + '</svg>';
  }
  function spider(len) {
    /* thread from the top, round body with 8 legs, 2 tiny eyes */
    var L = '';
    [[-1, 1], [1, 1]].forEach(function (sd) {
      var k = sd[0];
      L += '<path d="M' + (11 + 3 * k) + ' ' + (len + 3) + 'q' + (6 * k) + ' -5 ' + (9 * k) + ' -2M' + (11 + 3 * k) + ' ' + (len + 5) + 'q' + (7 * k) + ' -2 ' + (10 * k) + ' 2M' +
        (11 + 3 * k) + ' ' + (len + 7) + 'q' + (6 * k) + ' 2 ' + (8 * k) + ' 7M' + (11 + 2 * k) + ' ' + (len + 9) + 'q' + (4 * k) + ' 4 ' + (5 * k) + ' 9" />';
    });
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 ' + (len + 22) + '" aria-hidden="true" focusable="false">' +
      '<path d="M11 0V' + (len + 1) + '" stroke="rgba(242,244,239,.45)" stroke-width="1" fill="none"/>' +
      '<g stroke="#f2f4ef" stroke-width="1.2" fill="none" stroke-linecap="round">' + L + '</g>' +
      '<ellipse cx="11" cy="' + (len + 6) + '" rx="4.6" ry="5.4" fill="#f2f4ef"/><circle cx="11" cy="' + (len + 1) + '" r="2.8" fill="#f2f4ef"/>' +
      '<circle cx="9.9" cy="' + (len + 0.6) + '" r=".8" fill="#ff7a1a"/><circle cx="12.1" cy="' + (len + 0.6) + '" r=".8" fill="#ff7a1a"/></svg>';
  }
  function leagueScene() {
    var stars = [[430, 40], [480, 150], [530, 70], [590, 20], [640, 120], [690, 55], [760, 30], [800, 170], [1010, 40], [1060, 130], [1110, 70], [1170, 25],
      [1230, 110], [370, 100], [320, 30], [1290, 60], [560, 210], [1000, 200], [250, 150], [1350, 160]];
    var s = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 560" preserveAspectRatio="xMidYMin slice"><defs>' +
      '<linearGradient id="sk" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#15263a"/><stop offset=".6" stop-color="#0d1824"/><stop offset="1" stop-color="#0a131d"/></linearGradient>' +
      moonDefs('mo') +
      '<radialGradient id="gl"><stop offset="0" stop-color="#ff7a1a" stop-opacity=".30"/><stop offset="1" stop-color="#ff7a1a" stop-opacity="0"/></radialGradient>' +
      '<linearGradient id="bm" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#adff00" stop-opacity=".26"/><stop offset="1" stop-color="#adff00" stop-opacity="0"/></linearGradient>' +
      '<linearGradient id="fg" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#c6d6e6" stop-opacity="0"/><stop offset=".5" stop-color="#c6d6e6" stop-opacity=".10"/><stop offset="1" stop-color="#c6d6e6" stop-opacity="0"/></linearGradient>' +
      '<linearGradient id="bt" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#0a131d" stop-opacity="0"/><stop offset="1" stop-color="#0a131d"/></linearGradient></defs>' +
      '<rect width="1440" height="560" fill="url(#sk)"/>' +
      stars.map(function (p, i) { return '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="' + (i % 3 ? 1.1 : 1.7) + '" fill="#f2f4ef" opacity="' + (i % 2 ? .35 : .6) + '"/>'; }).join('') +
      '<circle cx="905" cy="96" r="170" fill="url(#gl)"/><circle cx="905" cy="96" r="64" fill="url(#mo)"/>' +
      '<circle cx="884" cy="84" r="7" fill="#e8650f" opacity=".22"/><circle cx="922" cy="116" r="10" fill="#e8650f" opacity=".18"/><circle cx="930" cy="72" r="5" fill="#e8650f" opacity=".2"/>' +
      bat(870, 92, 50, -10, NAVY) + bat(936, 128, 34, 12, NAVY) + bat(1050, 70, 30, 6, BATN) + bat(770, 150, 26, -12, BATN) + bat(1110, 160, 22, 4, BATN) + bat(560, 110, 24, -6, BATN) +
      /* floodlight towers with lime beams */
      '<path d="M462 218 L478 218 L760 470 L380 470 Z" fill="url(#bm)"/><path d="M962 218 L978 218 L1060 470 L680 470 Z" fill="url(#bm)"/>' +
      '<rect x="467" y="214" width="6" height="200" fill="#0e1a27"/><rect x="967" y="214" width="6" height="200" fill="#0e1a27"/>' +
      '<rect x="446" y="200" width="48" height="18" rx="2" fill="#0e1a27"/><rect x="946" y="200" width="48" height="18" rx="2" fill="#0e1a27"/>' +
      [452, 462, 472, 482, 952, 962, 972, 982].map(function (x) { return '<circle cx="' + (x + 2) + '" cy="209" r="3" fill="#e9ffb0"/>'; }).join('') +
      /* stadium bowl silhouette */
      '<path d="M0 470 L0 392 Q360 336 720 346 Q1080 336 1440 392 L1440 470 Z" fill="#0e1a27"/>' +
      '<path d="M0 392 Q360 336 720 346 Q1080 336 1440 392" fill="none" stroke="#64de19" stroke-opacity=".35" stroke-width="2"/>' +
      '<path d="M120 420 Q420 384 720 390 Q1020 384 1320 420" fill="none" stroke="#1e2b39" stroke-width="2"/>' +
      '<rect y="360" width="1440" height="140" fill="url(#fg)"/><rect y="440" width="1440" height="120" fill="url(#bt)"/></svg>';
    return s;
  }
  /* jack-o'-lantern pumpkin (not the football): used as corner flags and on the crest cards */
  function pumpkinFace(x, y, w) {
    var s = w / 32;
    return '<g transform="translate(' + (x - w / 2).toFixed(1) + ' ' + (y - w / 2).toFixed(1) + ') scale(' + s.toFixed(3) + ')">' +
      '<path d="M15 6c-.4-2.6.6-4.6 3-5.6l1 1.6c-1.6.9-2.1 2.3-1.9 4.1z" fill="#3d6b1e"/>' +
      '<path d="M16 7.6C13.8 6 10.8 6 8.8 7.4 4.6 7.8 2 12.2 2 18s3.2 10.4 7.2 10.8c2.2 1.4 4.8 1.2 6.8.2 2 1 4.6 1.2 6.8-.2 4-.4 7.2-5 7.2-10.8s-2.6-10.2-6.8-10.6c-2-1.4-5-1.4-7.2.2z" fill="#ff7a1a"/>' +
      '<path d="M11.2 8.4c-2 4-2 15.6 0 19.6M20.8 8.4c2 4 2 15.6 0 19.6" fill="none" stroke="#e8650f" stroke-width="1.2"/>' +
      '<path d="M8.5 15.5l3-4 3 4zM17.5 15.5l3-4 3 4zM7.5 20.5q8.5 6 17 0l-2 3.2-2-1.6-2.2 2-2.3-2-2.2 2-2.2-2-2 1.6z" fill="#0a131d"/></g>';
  }
  function leagueScene3() {
    var W = 1440, H = 620, out = [];
    var stars = [[60, 40], [140, 120], [230, 30], [310, 150], [380, 60], [470, 110], [520, 20], [610, 150], [660, 40], [760, 25], [800, 160], [1050, 40], [1100, 140],
      [1160, 60], [1230, 20], [1290, 120], [1350, 50], [1400, 150], [700, 95], [1010, 170], [440, 190], [1190, 190]];
    out.push('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 ' + W + ' ' + H + '"><defs>' +
      '<linearGradient id="sk" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#172c42"/><stop offset=".45" stop-color="#0f1c2a"/><stop offset="1" stop-color="#0a131d"/></linearGradient>' +
      moonDefs('mo') +
      '<radialGradient id="gl"><stop offset="0" stop-color="#ff7a1a" stop-opacity=".34"/><stop offset="1" stop-color="#ff7a1a" stop-opacity="0"/></radialGradient>' +
      '<linearGradient id="bm" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#adff00" stop-opacity=".30"/><stop offset="1" stop-color="#adff00" stop-opacity="0"/></linearGradient>' +
      '<linearGradient id="pt" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#103322"/><stop offset=".55" stop-color="#0c1f1a"/><stop offset="1" stop-color="#0a131d"/></linearGradient>' +
      '<radialGradient id="fo"><stop offset="0" stop-color="#c6d6e6" stop-opacity=".16"/><stop offset="1" stop-color="#c6d6e6" stop-opacity="0"/></radialGradient>' +
      '<linearGradient id="el" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#0a131d"/><stop offset="1" stop-color="#0a131d" stop-opacity="0"/></linearGradient>' +
      '<linearGradient id="er" x1="1" y1="0" x2="0" y2="0"><stop offset="0" stop-color="#0a131d"/><stop offset="1" stop-color="#0a131d" stop-opacity="0"/></linearGradient>' +
      '<symbol id="g" viewBox="0 0 40 48"><path d="M20 2C9.5 2 4 10 4 20.5V44l5-4 5.3 5 5.7-5 5.7 5 5.3-5 5 4V20.5C36 10 30.5 2 20 2z" fill="#f2f4ef"/>' +
      '<ellipse cx="14.5" cy="19" rx="2.7" ry="3.8" fill="#0a131d"/><ellipse cx="25.5" cy="19" rx="2.7" ry="3.8" fill="#0a131d"/><ellipse cx="20" cy="29" rx="2.6" ry="3.2" fill="#0a131d"/></symbol>' +
      '<symbol id="gs" viewBox="0 0 60 60"><path d="M15 30Q8 22 7 12M45 30Q52 22 53 12" stroke="#f2f4ef" stroke-width="3.2" fill="none" stroke-linecap="round"/>' +
      '<rect x="2" y="5" width="56" height="9" rx="1.5" fill="currentColor"/><path d="M12 5v9M22 5v9M32 5v9M42 5v9" stroke="#0a131d" stroke-width="2.4" opacity=".55"/>' +
      '<path d="M3 14v4M6 14v4M54 14v4M57 14v4" stroke="currentColor" stroke-width="1.6"/>' +
      '<g transform="translate(10 12)"><path d="M20 2C9.5 2 4 10 4 20.5V44l5-4 5.3 5 5.7-5 5.7 5 5.3-5 5 4V20.5C36 10 30.5 2 20 2z" fill="#f2f4ef"/>' +
      '<ellipse cx="14.5" cy="19" rx="2.7" ry="3.8" fill="#0a131d"/><ellipse cx="25.5" cy="19" rx="2.7" ry="3.8" fill="#0a131d"/><ellipse cx="20" cy="28" rx="3.6" ry="4.2" fill="#0a131d"/></g></symbol>' +
      '</defs>');
    out.push('<rect width="' + W + '" height="' + H + '" fill="url(#sk)"/>');
    stars.forEach(function (p, i) { out.push('<circle cx="' + p[0] + '" cy="' + p[1] + '" r="' + (i % 3 ? 1.1 : 1.8) + '" fill="#f2f4ef" opacity="' + (i % 2 ? .4 : .7) + '"/>'); });
    /* moon + bats */
    out.push('<circle cx="935" cy="80" r="190" fill="url(#gl)"/><circle cx="935" cy="80" r="72" fill="url(#mo)"/>' +
      '<circle cx="912" cy="66" r="9" fill="#e8650f" opacity=".2"/><circle cx="956" cy="104" r="12" fill="#e8650f" opacity=".16"/><circle cx="962" cy="58" r="6" fill="#e8650f" opacity=".2"/>');
    out.push(bat(905, 76, 52, -10, NAVY) + bat(968, 110, 36, 12, NAVY) + bat(1080, 46, 30, 6, '#3e5266') + bat(1130, 120, 22, -8, '#3e5266') + bat(780, 40, 24, 8, '#3e5266') + bat(300, 90, 26, -6, '#3e5266') + bat(1300, 80, 26, 10, '#3e5266'));
    /* flying jack-o'-lantern football with bat wings (the campaign mascot) */
    out.push('<g transform="translate(600 52) rotate(-10)">' +
      '<path d="M-14 -2C-30 -22 -52 -24 -66 -12c8 0 12 4 13 9 4-4 10-3 13 2 3-4 9-3 12 2z" fill="#3e5266"/>' +
      '<path d="M14 -2C30 -22 52 -24 66 -12c-8 0-12 4-13 9-4-4-10-3-13 2-3-4-9-3-12 2z" fill="#3e5266"/>' +
      '<svg x="-26" y="-28" width="52" height="52" viewBox="0 0 64 64">' + jack(true, '#64de19').replace(/^<svg[^>]*>/, '').replace(/<\/svg>$/, '') + '</svg></g>');
    /* floodlight towers with lime beams */
    [[150, 1], [430, 1], [1010, -1], [1290, -1]].forEach(function (t) {
      var x = t[0], d = t[1];
      out.push('<path d="M' + (x - 14) + ' 128 L' + (x + 14) + ' 128 L' + (x + 230 * d + 60) + ' 520 L' + (x + 230 * d - 120) + ' 520 Z" fill="url(#bm)"/>' +
        '<rect x="' + (x - 3) + '" y="124" width="6" height="130" fill="#13202e"/><rect x="' + (x - 24) + '" y="110" width="48" height="18" rx="2" fill="#13202e"/>' +
        [-16, -6, 4, 14].map(function (o) { return '<circle cx="' + (x + o + 2) + '" cy="119" r="3" fill="#eaffb6"/>'; }).join(''));
    });
    /* the curva: roof, stands and three rows of ghost ultras */
    out.push('<path d="M0 238 Q720 192 1440 238 L1440 252 Q720 206 0 252 Z" fill="#162636"/>' +
      '<path d="M0 238 Q720 192 1440 238" fill="none" stroke="#64de19" stroke-opacity=".55" stroke-width="2"/>' +
      '<path d="M0 252 Q720 206 1440 252 L1440 400 L0 400 Z" fill="#0e1a27"/>');
    var rows = [{ y: 262, s: 22, step: 27, op: .5 }, { y: 296, s: 28, step: 33, op: .72 }, { y: 336, s: 34, step: 40, op: 1 }];
    rows.forEach(function (r, ri) {
      var n = 0;
      for (var x = 10 + ri * 9; x < W; x += r.step) {
        var curve = (Math.pow((x - 720) / 720, 2)) * 40; /* follow the curve of the stand */
        var jit = Math.sin(x * .37 + ri) * 3;
        var y = r.y + curve * (1 - ri * .15) + jit;
        var scarf = (n + ri) % 4 === 1, col = (n % 2) ? '#ff7a1a' : '#64de19';
        if (scarf) out.push('<use xlink:href="#gs" href="#gs" x="' + (x - r.s * .75).toFixed(1) + '" y="' + (y - r.s * .3).toFixed(1) + '" width="' + (r.s * 1.5).toFixed(1) + '" height="' + (r.s * 1.5).toFixed(1) + '" color="' + col + '" opacity="' + r.op + '"/>');
        else out.push('<use xlink:href="#g" href="#g" x="' + (x - r.s / 2).toFixed(1) + '" y="' + y.toFixed(1) + '" width="' + r.s + '" height="' + (r.s * 1.2).toFixed(1) + '" opacity="' + r.op + '"/>');
        n++;
      }
    });
    /* railing + the striscione */
    out.push('<rect y="384" width="' + W + '" height="16" fill="#122131"/><rect y="384" width="' + W + '" height="2" fill="#1e2b39"/>' +
      '<rect x="548" y="366" width="344" height="40" rx="3" fill="#0a131d" stroke="#64de19" stroke-width="2"/>' +
      '<text x="720" y="396" text-anchor="middle" font-family="Impact,Haettenschweiler,\'Arial Narrow Bold\',\'Roboto Condensed\',\'Arial Narrow\',sans-serif" font-weight="700" font-size="28" letter-spacing="2" fill="#adff00">CURVA DA PAURA</text>' +
      pumpkinFace(530, 386, 30) + pumpkinFace(910, 386, 30));
    /* pitch with glowing lines, pumpkin corner flags and fog */
    out.push('<rect y="400" width="' + W + '" height="220" fill="url(#pt)"/>' +
      '<path d="M0 432H' + W + '" stroke="#64de19" stroke-opacity=".6" stroke-width="2.5"/>' +
      '<path d="M720 432V620" stroke="#64de19" stroke-opacity=".4" stroke-width="2"/>' +
      '<ellipse cx="720" cy="548" rx="170" ry="46" fill="none" stroke="#64de19" stroke-opacity=".4" stroke-width="2"/>' +
      '<path d="M455 432L405 470M985 432L1035 470" stroke="#64de19" stroke-opacity=".35" stroke-width="2"/>' +
      '<path d="M455 432V400M985 432V400" stroke="#f2f4ef" stroke-width="2"/><path d="M455 400l16 5-16 5zM985 400l-16 5 16 5z" fill="#ff7a1a"/>' +
      pumpkinFace(455, 440, 34) + pumpkinFace(985, 440, 34) +
      '<ellipse cx="560" cy="470" rx="320" ry="34" fill="url(#fo)"/><ellipse cx="930" cy="500" rx="360" ry="40" fill="url(#fo)"/><ellipse cx="720" cy="540" rx="520" ry="50" fill="url(#fo)"/>' +
      '<rect x="0" y="0" width="140" height="' + H + '" fill="url(#el)"/><rect x="' + (W - 140) + '" y="0" width="140" height="' + H + '" fill="url(#er)"/>' +
      '<rect y="560" width="' + W + '" height="60" fill="#0a131d" opacity=".6"/></svg>');
    return out.join('');
  }
  function crestCard() {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" preserveAspectRatio="none">' +
      '<rect x="0" y="0" width="200" height="200" rx="14" fill="#ffffff"/>' +
      '<rect x="8" y="8" width="184" height="184" rx="9" fill="none" stroke="#ff7a1a" stroke-opacity=".7" stroke-width="1.5"/>' +
      web('rgba(10,19,29,.30)').replace('<svg ', '<svg x="8" y="8" width="40" height="40" ').replace(' aria-hidden="true" focusable="false"', '') +
      bat(181, 17, 18, 10, NAVY) + bat(163, 11, 11, -8, NAVY) +
      pumpkinFace(185, 185, 21) + '</svg>';
  }
  function leaguePattern() {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">' +
      '<g opacity=".55">' + bat(46, 40, 24, -8, BATN) + bat(150, 150, 18, 10, BATN) + '</g>' +
      '<g transform="translate(130 50) scale(1.1)" opacity=".28">' +
      '<path d="M8 4.3C6.9 3.5 5.4 3.5 4.4 4.2 2.3 4.4 1 6.6 1 9.5s1.6 5.2 3.6 5.4c1.1.7 2.4.6 3.4.1 1 .5 2.3.6 3.4-.1 2-.2 3.6-2.5 3.6-5.4s-1.3-5.1-3.4-5.3c-1-.7-2.5-.7-3.6.1z" fill="#ff7a1a"/></g>' +
      '<circle cx="90" cy="120" r="1.3" fill="#f2f4ef" opacity=".35"/><circle cx="20" cy="170" r="1" fill="#f2f4ef" opacity=".3"/><circle cx="180" cy="20" r="1.2" fill="#f2f4ef" opacity=".3"/>' +
      '<circle cx="60" cy="90" r=".9" fill="#adff00" opacity=".3"/></svg>';
  }
  /* drip tiles: [x, length, width] on a 720px tile; 8 drops, uneven 38-127 px gaps, <=8 px long in x 230-330 */
  var D_DEEP = [[26, 9, 10], [64, 4, 7], [140, 5, 8], [225, 8, 10], [352, 12, 11], [470, 5, 8], [560, 13.5, 13], [650, 7, 9]];
  var D_SHALLOW = [[26, 5, 8], [64, 3, 6], [140, 3.5, 6], [225, 5, 8], [352, 7, 9], [470, 3.5, 6], [560, 8, 11], [650, 4.5, 7]];
  var LIP = [2.2, -1.6, 1.4, -2.4, .8, 2.4, -1.2, 1.8, -.6, 2, -2, 1.2, -1.4, 1.6];
  function dripPath(W, drips) {
    var d = 'M0 0H' + W + 'V3', waves = LIP.length, st = W / waves;
    for (var i = waves; i > 0; i--) {
      var x1 = (i - 1) * st, xm = (i - .5) * st, a = LIP[i - 1];
      d += 'Q' + xm.toFixed(1) + ' ' + (3 + a).toFixed(2) + ' ' + x1.toFixed(1) + ' 3';
    }
    d += 'Z';
    drips.forEach(function (q) {
      var x = q[0], len = q[1], w = q[2], r = Math.min(w * .42, 5.4), top = 1.2, bot = 2.2 + Math.max(len, r + 1.2);
      d += 'M' + (x - w / 2) + ' ' + top + 'C' + (x - w * .22).toFixed(2) + ' ' + (top + .6) + ' ' + (x - r).toFixed(2) + ' ' + (top + len * .35).toFixed(2) + ' ' + (x - r).toFixed(2) + ' ' + (bot - r).toFixed(2) +
           'A' + r.toFixed(2) + ' ' + r.toFixed(2) + ' 0 0 0 ' + (x + r).toFixed(2) + ' ' + (bot - r).toFixed(2) +
           'C' + (x + r).toFixed(2) + ' ' + (top + len * .35).toFixed(2) + ' ' + (x + w * .22).toFixed(2) + ' ' + (top + .6) + ' ' + (x + w / 2) + ' ' + top + 'Z';
    });
    return d;
  }
  function dripTile(H, drips, color, edge) {
    var d = dripPath(720, drips), k = d.indexOf('Z') + 1, lip = d.slice(0, k), drops = d.slice(k);
    var two = function (fill, t) { return '<path d="' + lip + '" fill="' + fill + '"' + t + '/><path d="' + drops + '" fill="' + fill + '"' + t + '/>'; };
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 720 ' + H + '" width="720" height="' + H + '" preserveAspectRatio="none">' +
      (edge ? two(edge, ' transform="translate(0 1)"') : '') + two(color, '') + '</svg>';
  }
  function codeButton(cls, label) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = cls; b.textContent = label || HW.code;
    b.setAttribute('aria-label', 'Copia il codice ' + HW.code); b.setAttribute('data-hw-code', HW.code);
    return b;
  }
  var live = null;
  function announce(msg) {
    if (!live) { live = document.createElement('span'); live.className = 'visually-hidden'; live.setAttribute('aria-live', 'polite'); document.body.appendChild(live); }
    live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 50);
  }
  function legacyCopy(txt) {
    var i = document.createElement('input'), ok = false;
    i.value = txt; i.readOnly = true; i.tabIndex = -1; i.setAttribute('aria-hidden', 'true');
    i.style.cssText = 'position:fixed;left:-9999px;top:0;font-size:16px';
    document.body.appendChild(i);
    try { i.select(); i.setSelectionRange(0, 99); ok = document.execCommand('copy'); } catch (err) { ok = false; }
    document.body.removeChild(i);
    return ok;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hw-code]');
    if (!b) return;
    e.preventDefault();
    if (b.__hwBusy) return;
    b.__hwBusy = true;
    if (b.__hwHtml == null) b.__hwHtml = b.innerHTML;
    var finish = function (ok) {
      if (!ok) { b.__hwBusy = false; return; }
      b.textContent = b.getAttribute('data-hw-done') || 'COPIATO ✓';
      announce('Codice copiato');
      setTimeout(function () { b.innerHTML = b.__hwHtml; b.__hwBusy = false; }, 1500);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(HW.code).then(function () { finish(true); }, function () { finish(legacyCopy(HW.code)); });
    else finish(legacyCopy(HW.code));
  });
  function safe(fn) { try { fn(); } catch (err) { console.warn('[hw preview]', err); } }

  /* ---------- GLB-04 drawer row ---------- */
  safe(function () {
    var ul = document.querySelector('.menu-drawer__navigation > .menu-drawer__menu');
    if (!ul || ul.querySelector('.hw-drawer-row')) return;
    var li = document.createElement('li'); li.className = 'hw-drawer-row';
    li.innerHTML = '<a class="menu-drawer__menu-item list-menu__item link link--text focus-inset" href="' + HW.link + '">' +
      '<span class="hw-drawer-row__glyph">' + glyph(PUMP, NAVY) + '</span>SCONTI DI HALLOWEEN</a>';
    ul.insertBefore(li, ul.firstChild);
  });

  /* ---------- GLB-05 cart bubble: count real products only ---------- */
  safe(function () {
    var bubble = document.querySelector('.header__icon--cart .cart-count-bubble span[aria-hidden]');
    if (!bubble) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var n = 0; c.items.forEach(function (i) { if (i.variant_id !== 49506321006920 && i.variant_id !== 49498744324424) n += i.quantity; });
      if (n > 0) bubble.textContent = n;
    });
  });

  /* ---------- GLB-07 footer: Halloween scene in the empty space above the logo (company line untouched) ---------- */
  safe(function () {
    var f = document.querySelector('footer.footer');
    if (!f || document.querySelector('.hw-foot-scene')) return;
    var sc = document.createElement('div'); sc.className = 'hw-foot-scene';
    sc.innerHTML = '<span class="hw-fs-spider" aria-hidden="true">' + spider(30) + '</span>' +
      '<span class="hw-fs-web" aria-hidden="true">' + web('rgba(242,244,239,.16)') + '</span>' +
      '<p class="hw-signoff"><span class="hw-signoff__glyph">' + glyph(PUMP, NAVY) + '</span>BUON HALLOWEEN DA OUTLET DEL CALCIO</p>' +
      '<span class="hw-fs-bats" aria-hidden="true">' + batsSvg(96, 40, [[20, 30, 26, -12, '#45596e'], [52, 18, 20, 8, '#45596e'], [80, 8, 14, -6, '#45596e']]) + '</span>';
    f.insertBefore(sc, f.firstChild);
  });

  /* ---------- HOME-04 offer band takeover + HOME-15 FAQ entry ---------- */
  safe(function () {
    if (tpl !== 'index') return;
    var root = document.querySelector('[data-odc-home="offer"]'), end = new Date(HW.end).getTime();
    if (root && Date.now() < end) {
      /* the timer stays the site's own daily 24 h countdown to midnight (odc-home.js); only copy, colour and decoration change */
      var lead = root.querySelector('.oh-lead'), timer = root.querySelector('.oh-timer'), lbl = root.querySelector('.oh-lbl');
      if (lead) lead.textContent = 'Sconti di Halloween';
      if (lbl) lbl.textContent = 'Scade tra';
      if (timer) timer.setAttribute('aria-label', 'Scade tra');
      var deco = document.createElement('div'); deco.className = 'hw-offer-deco'; deco.setAttribute('aria-hidden', 'true');
      deco.innerHTML = '<span class="hw-od-web">' + web('rgba(242,244,239,.20)') + '</span>' +
        '<span class="hw-od-ghost hw-od-ghost1">' + ghost() + '</span><span class="hw-od-ghost hw-od-ghost2">' + ghost() + '</span>' +
        '<span class="hw-od-bats">' + batsSvg(80, 40, [[18, 30, 22, -12, '#2b3b4c'], [44, 18, 18, 8, '#2b3b4c'], [68, 10, 13, -6, '#2b3b4c']]) + '</span>' +
        '<span class="hw-od-bats hw-od-bats2">' + batsSvg(60, 30, [[16, 20, 18, 10, '#2b3b4c'], [44, 10, 13, -8, '#2b3b4c']]) + '</span>';
      root.insertBefore(deco, root.firstChild);
      if (C.codeOk) {
      var row = document.createElement('div'); row.className = 'hw-code-row';
      var chip = codeButton('hw-chip', '');
      chip.setAttribute('data-hw-done', 'Codice copiato!');
      chip.innerHTML = 'Codice <b>' + HW.code + '</b>';
      var small = document.createElement('span'); small.className = 'hw-chip-note';
      small.innerHTML = '-' + HW.percent + '% extra su migliaia di maglie · <span class="hw-tap">Tocca</span><span class="hw-click">Clicca</span> per copiare';
      row.appendChild(chip); row.appendChild(small);
      root.querySelector('.oh-wrap').appendChild(row);
      }
      root.classList.add('hw-ready');
    }
    var qas = document.querySelectorAll('.odc-home.oh-faq .oh-qa');
    if (C.codeOk && qas.length && !document.querySelector('.hw-faq')) {
      var last = qas[qas.length - 1], n = last.cloneNode(true);
      n.classList.add('hw-faq'); n.removeAttribute('open');
      var qq = n.querySelector('.oh-qa-q');
      if (qq) qq.innerHTML = '<span class="oh-qa-n">' + (qas.length + 1) + '.</span> C’è uno sconto per Halloween?';
      var body = n.querySelector('.oh-qa-body');
      if (body) body.innerHTML = '<p>Sì: fino a mezzanotte, con il codice <b>' + HW.code + '</b> hai il ' + HW.percent +
        '% di sconto extra su <a href="' + HW.link + '">migliaia di maglie</a>. Inseriscilo al checkout; il codice non è cumulabile con altri sconti.</p>';
      last.parentNode.appendChild(n);
    }
  });

  /* ---------- COL-01 band countdown (the band itself is server-rendered) ---------- */
  safe(function () {
    var sec = document.querySelector('.hw-colbanner');
    if (!sec) return;
    var pad2 = function (n) { return (n < 10 ? '0' : '') + n; };
    var q2 = function (k) { return sec.querySelector('[data-ct="' + k + '"]'); };
    var tick2 = function () {
      var now = new Date(), endD = new Date(now); endD.setHours(23, 59, 59, 999);
      var d = Math.max(0, endD - now);
      q2('h').textContent = pad2(Math.floor(d / 3600000)); q2('m').textContent = pad2(Math.floor(d % 3600000 / 60000)); q2('s').textContent = pad2(Math.floor(d % 60000 / 1000));
    };
    tick2(); setInterval(tick2, 1000);
  });
  safe(function () {
    document.querySelectorAll('.badge__percent').forEach(function (b) {
      var card = b.closest('li, .card-wrapper, .grid__item');
      if (card && !card.querySelector('.price--on-sale')) b.classList.add('hw-badge-fake');
    });
  });

  /* ---------- PDP-03 code line (default template) + PDP-09 mystery line ---------- */
  safe(function () {
    if (tpl !== 'product') return;
    if (mystery) {
      var t = document.querySelector('.product_title');
      if (t && !document.querySelector('.hw-mystery')) {
        var m = document.createElement('div'); m.className = 'hw-mystery';
        m.innerHTML = '<p class="hw-mystery__1">Dolcetto o scherzetto?</p><p class="hw-mystery__2">Qui il dolcetto è una maglia a sorpresa.</p>';
        t.parentNode.insertBefore(m, t.nextSibling);
      }
      return;
    }
    if (!C.codeOk || !C.eligible) return;
    var loc = document.getElementById('user_location');
    var anchor = loc ? loc.closest('.product__info-container > *') : null;
    if (!anchor) { var pr = document.querySelector('.product__info-container .price'); anchor = pr ? pr.closest('.product__info-container > *') : null; }
    if (!anchor || document.querySelector('.hw-pdp-offer')) return;
    var o = document.createElement('div'); o.className = 'hw-pdp-offer';
    o.innerHTML = '<span class="hw-pdp-offer__glyph">' + glyph(PUMP, '#ffffff', 18) + '</span><span><b>-' + HW.percent + '% extra</b> con</span>';
    var chip = codeButton('hw-pdp-offer__code'); chip.setAttribute('data-hw-done', 'Copiato ✓');
    o.appendChild(chip);
    var u = document.createElement('span'); u.className = 'hw-pdp-offer__until'; u.innerHTML = '<span class="hw-pdp-offer__fino">fino a mezzanotte</span>';
    o.appendChild(u);
    anchor.parentNode.insertBefore(o, anchor.nextSibling);
  });

  /* ---------- CART-01 dolcetto copy + CART-02 milestone + CART-07 empty cart ---------- */
  safe(function () {
    if (tpl !== 'cart') return;
    var p = document.querySelector('.upcart-rewards-message p');
    if (p) {
      var rewrite = function () {
        var t = p.textContent.replace(/\s+/g, ' ').trim(), m;
        if ((m = t.match(/^Ti mancano solo (€\s?[\d.,]+) per ricevere un REGALO SEGRETO in omaggio!$/))) {
          obs.disconnect(); p.innerHTML = '<strong class="hw-lead">Dolcetto o scherzetto?</strong> Ti mancano solo <span class="money">' + m[1] + '</span> per il REGALO SEGRETO in omaggio!'; obs.observe(p, cfg);
        } else if ((m = t.match(/^Ti mancano solo (€\s?[\d.,]+) per ottenere la SPEDIZIONE GRATUITA!$/))) {
          obs.disconnect(); p.innerHTML = '<strong class="hw-lead">Niente scherzetti:</strong> ti mancano solo <span class="money">' + m[1] + '</span> per la SPEDIZIONE GRATUITA!'; obs.observe(p, cfg);
        } else if (/^Hai conquistato un REGALO SEGRETO in omaggio!$/.test(t)) {
          obs.disconnect(); p.innerHTML = '<strong class="hw-lead">Dolcetto sbloccato:</strong> il REGALO SEGRETO è tuo!'; obs.observe(p, cfg);
        }
      };
      var cfg = { childList: true, characterData: true, subtree: true }, obs = new MutationObserver(rewrite);
      rewrite(); obs.observe(p, cfg);
    }
    var fg = document.querySelector('.upcart-rewards-bar-foreground');
    var circ = document.querySelector('.custom-progress-container > .upcart-rewards-tier:last-child .upcart-rewards-tier-circle');
    if (fg && circ) {
      var was = null;
      var set = function () {
        if (!fg.style.width) return;
        var r = parseFloat(fg.style.width) >= 100;
        circ.classList.toggle('hw-reached', r);
        if (was === false && r) circ.classList.add('hw-pop');
        was = r;
      };
      circ.addEventListener('animationend', function () { circ.classList.remove('hw-pop'); });
      set(); new MutationObserver(set).observe(fg, { attributes: true, attributeFilter: ['style'] });
    }
    /* free-shipping step: night circle once reached (€35 of €50 = 70% of the bar) + bats on every "spedizione gratis" mention */
    var ships = document.querySelectorAll('.upcart-rewards-tier-circle.free-shipping-icon');
    if (fg && ships.length) {
      var setS = function () {
        if (!fg.style.width) return;
        var r = parseFloat(fg.style.width) >= 69.9;
        ships.forEach(function (s) { s.classList.toggle('hw-reached', r); if (s.parentNode) s.parentNode.classList.add('hw-ship-tier'); });
      };
      setS(); new MutationObserver(setS).observe(fg, { attributes: true, attributeFilter: ['style'] });
    }
    document.querySelectorAll('.cart_free_shipping, .cart-support').forEach(function (s) {
      if (/spedizione (gratis|gratuita)/i.test(s.textContent)) s.classList.add('hw-bat-after');
    });
    var empty = document.querySelector('cart-items.is-empty, .is-empty');
    var heading = document.querySelector('.cart__empty-text');
    if (empty && heading && !document.querySelector('.hw-empty-sub')) {
      var ic = document.createElement('div'); ic.className = 'hw-empty-icon'; ic.innerHTML = jack(true, '#64de19');
      heading.parentNode.insertBefore(ic, heading);
      var sub = document.createElement('p'); sub.className = 'hw-empty-sub'; sub.textContent = 'Fa più paura di un rigore al 90’.';
      heading.parentNode.insertBefore(sub, heading.nextSibling);
      try { clearInterval(timerInterval); } catch (err) {}
      var pill = heading.parentNode.querySelector('a.button');
      if (pill && html.classList.contains('hw-has-code') && !document.querySelector('.hw-empty-code')) {
        var cl = document.createElement('p'); cl.className = 'hw-empty-code';
        cl.innerHTML = 'Halloween: -' + HW.percent + '% extra su migliaia di maglie con il codice <b>' + HW.code + '</b>';
        pill.parentNode.insertBefore(cl, pill.nextSibling);
      }
    }
  });
  /* switch off on pages still open at the end */
  safe(function () { var e = Date.parse(HW.end), l = e - Date.now(); if (e && l > 0 && l < 2e9) setTimeout(function () {
    html.className = html.className.replace(/(^|\s)hw-[\w-]+/g, ''); }, l); });
})();
